import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import api from "../../../../../store/api";
import { AppThunk } from "../../../../../store/app";
import Config from "../../../../../config/Config";
import { apiUrls } from "./apiUrls";

interface InitialState {
  isLoading: boolean;
  agGrid: any;
  perPage: any;
  details: any;
}

const initialState = {
  isLoading: false,
  agGrid: null,
  perPage: Config.grid.server.gridOptions?.paginationPageSize,
  details: null,
} as InitialState;

const landingPageSlice = createSlice({
  name: "landingPageSlice",
  initialState,
  reducers: {
    start: state => {
      state.isLoading = true;
    },
    success: state => {
      state.isLoading = false;
    },
    failure: state => {
      state.isLoading = false;
    },
    setDetails: (state, action: PayloadAction<any>) => {
      state.details = action.payload;
    },
  },
});

export const { start, success, failure, setDetails } = landingPageSlice.actions;

export const details = (): AppThunk<any> => async dispatch => {
  try {
    const response = await api.get(apiUrls.details);
    dispatch(setDetails(response?.data?.rows));
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error.data);
  }
};

export const updateRecord =
  (data: any): AppThunk<any> =>
  async dispatch => {
    try {
      dispatch(start());
      const response = await api.post(apiUrls.update, data);
      dispatch(success(response.data));
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure(error.data));
      return Promise.reject(error.data);
    }
  };

const landingPageReducer = landingPageSlice.reducer;
export default landingPageReducer;
